import { render, staticRenderFns } from "./classical-exam-validation-score.vue?vue&type=template&id=2cdc3006"
import script from "./classical-exam-validation-score.vue?vue&type=script&lang=js"
export * from "./classical-exam-validation-score.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports